<header class="flex justify-content-between">
  <div class="menu flex">
    @if (!hideHeader()) {
      <span class="menu-button"
        [class.open]="isMenuOpen()"
        (click)="onToggleMenu()">
        <span class="lines">
          <span class="line"></span>
        </span>
      </span>
    }

    @if (!hideHeader()) {
      <a href="/" class="logo flex align-items-center">
        <img style="width: 96px; height:auto" src="assets/images/evo-logo-white-v3.png" alt="Logo">
      </a>
    }

    @if (hideHeader()) {
      <div class="logo flex align-items-center">
        <img style="width: 96px; height:auto" src="assets/images/evo-logo-white-v3.png" alt="Logo">
      </div>
    }
  </div>

  @if (!hideHeader()) {
    <div class="user-info flex align-items-center">
      @if (user | async; as userData) {
        <div ngbDropdown placement="bottom-end">
          <button class="flex align-items-center no-caret" ngbDropdownToggle>
            @if (userData.is_staff) {
              @if (totalCount$ | async; as count) {
                @if (count > 0) {
                  <span class="bell-wrap me-2">
                    <i class="fas fa-bell"></i>
                    <span class="notification-badge">{{ count }}</span>
                  </span>
                }
              }
            }
            <img src="assets/images/user-profile.svg" alt="Profile">
            <span>{{userData.name || 'User'}}</span>
          </button>
          <div ngbDropdownMenu>
            @if (userData.is_staff) {
              <button ngbDropdownItem class="notification-item" (click)="openNotifications()">
                Notifications
                @if (totalCount$ | async; as count) {
                  @if (count > 0) {
                    <span class="menu-badge">{{ count }}</span>
                  }
                }
              </button>
            }
            <button ngbDropdownItem (click)="onLogout()">Log Out</button>
          </div>
        </div>
      } @else {
        <button class="flex align-items-center" (click)="onLogin()">
          <img src="assets/images/user-profile.svg" alt="Login">
          <span>Login</span>
        </button>
      }
    </div>
  }
</header>
